import tw, { styled } from 'twin.macro';

export const StyledLogo = styled.li`
  ${tw`shrink-0`}
`;

export const StyledLinkTitle = styled.span`
  ${tw`sr-only`}
`;

export const StyledLink = styled.a``;
